/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RegisteredInputs */



/**
* | output |
* | --- |
* | "Registered" |
*
* @param {RegisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const registered = /** @type {((inputs?: RegisteredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RegisteredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistré")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingetragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Зарегистрировано")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("挂号的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("登録済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दर्ज कराई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registrado")
	return /** @type {LocalizedString} */ ("Registered")
});